import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Roadmap = lazy(() =>
  import("@scenes/Resources/Roadmap").then((module) => ({
    default: module.Roadmap,
  }))
);

export const roadmapNRO: NavigationRoutingObject = {
  Component: Roadmap,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings", // Actually in The TopNavigationCommunityMenu
  heading: (t: I18nT<"dashboard-navigation">) => t("roadmap-nro-heading", "Product roadmap"),
  pageNameForTracking: () => "Product roadmap",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("roadmap-nro-description", "Check out what’s new and upcoming, or submit your ideas to the team"),
  icon: "nav-system-product-roadmap",
  getDeveloperNavigationAllowed: () => true,
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
